/// <reference path="question.ts" />
/// <reference path="../interfaces/iproduct.ts" />

module App.Classes {
    export class Product implements Interfaces.IProduct {
        category: string;
        subCategory: string;
        name: string;
        id: string;
        units: number;
        code: string;
        groupName: string;
        description: string;
        descriptionMail: string;
        price: number;
        discountPrice: number;
        popupText: string;
        isReminderProduct: boolean;
        type: any;
        showProductTextField: boolean;
        productExtraTextField: string;
        noSaturday: boolean;
        customerWaiting: boolean;
        question: Question;
    }
}